import React, { Component } from 'react';
import './header.css'
class Header extends Component {

  clickLogo = (name) => {
    window.ga('send', 'event', 'logo', 'click', name);
  }

  render() {
    return (
      <div className="header">
        <div className="logo__championat">
          <a href="https://www.championat.com/" target="_blank">
            <img src="/images/championat.svg" alt="" />
          </a>
        </div>

        <div className="specproject">
          <a>СПЕЦПРОЕКТ</a>
        </div>

        <div className="mir__logo">
          <a  href="https://mironline.ru" target="_blank" onClick={(e) => this.clickLogo('Mir')}>
            <img src="/images/mir_logo.svg" alt="" />
          </a>
        </div>

        <div className="russia__logo">
          <a href="https://rfs.ru/" target="_blank" onClick={(e) => this.clickLogo('RFS')}>
            <img src="/images/rf.svg" alt="" />
          </a>
        </div>

        
      </div>
    );
  }
}

export default Header;